import { Component, EventEmitter, OnInit, Output } from "@angular/core";
import { FilterService } from "../../../../services/filter.service";
import { ByAssigned } from "../../../../model/filters/by-assigned";
import { ByBranch } from "../../../../model/filters/by-branch";
import { ByDepartment } from "../../../../model/filters/by-department";
import { ByRegistered } from "../../../../model/filters/by-registered";
import { ByStatus } from "../../../../model/filters/by-status";
import { ByTitle } from "../../../../model/filters/by-title";
import { ByPriority } from "../../../../model/filters/by-priority";
import { ById } from "../../../../model/filters/by-id";
import { Router } from "@angular/router";
import { Newest } from "../../../../model/filters/newest";
import { NavigationHelper } from "../../../../services/navigation.helper";
import { Filter } from "../../../../model/filters/filter";
import { MatchAll } from "../../../../model/filters/match-all";
import { Archived } from "../../../../model/filters/archived";
import { Active } from "../../../../model/filters/active";

@Component({
    selector: "filter-for-ticket",
    templateUrl: "./filter-for-ticket.component.html",
    styleUrls: ["./filter-for-ticket.component.css"],
})
export class FilterForTicketComponent implements OnInit {
    filters = [
        {
            filter: new ByAssigned(1),
            icon: "person",
            disabled: false,
            label: "filter.byAssigned",
        },
        {
            filter: new ByBranch(2),
            icon: "business",
            disabled: false,
            label: "filter.byBranch",
        },
        {
            filter: new ByDepartment(3),
            icon: "apartment",
            disabled: false,
            label: "filter.byAfdeling",
        },
        {
            filter: new ByRegistered(4),
            icon: "how_to_reg",
            disabled: false,
            label: "filter.byRegistered",
        },
        {
            filter: new ByStatus(0),
            icon: "check_circle",
            disabled: false,
            label: "filter.byStatus",
        },
        {
            filter: new ByTitle(""),
            icon: "title",
            disabled: false,
            label: "filter.byTitle",
        },
        //        {
        //            filter: new ByPriority(6),
        //            icon: "error_circle",
        //            disabled: false,
        //            label: "filter.byPriority",
        //        },
        //        {
        //            filter: new ById(0),
        //            icon: "tag",
        //            disabled: false,
        //            label: "filter.byId",
        //        },
        //        {
        //            filter: new Newest(0),
        //            icon: "new_releases",
        //            disabled: false,
        //            label: "filter.newest",
        //        },
        //        {
        //            filter: new Active(),
        //            icon: "toggle_on",
        //            disabled: false,
        //            label: "filter.active",
        //        },
        {
            filter: new Archived(),
            icon: "archive",
            disabled: false,
            label: "filter.archived",
        },
    ];

    appliedFilters: Filter[] = [];
    selectedFilterCode: string = "";

    @Output() filterSelected = new EventEmitter<Filter>();

    constructor(
        private filterService: FilterService,
        private router: Router,
        private nav: NavigationHelper
    ) { }

    ngOnInit() {
        this.nav.fragmentTopics.subscribe((code) => {
            this.applyAllFromNavigation();
        });

        this.filterService.filterObservable.subscribe((matchAll) => {
            this.appliedFilters = (matchAll as MatchAll).filters;
        });
    }

    applyFilter(filterCode: string): void {
        this.selectedFilterCode = filterCode;

        const selectedFilter = this.filters.find(
            (f) => f.filter.code === filterCode
        )?.filter;

        if (selectedFilter) {
            this.filterSelected.emit(selectedFilter);
        }

        const url = `/tickets/-1/filter/${filterCode}`;
        this.router.navigate([url]).then(() => {
            this.nav.freshNavigation;
        });
    }

    removeFilter(event: { filter: any; valueIndex: number | null }): void {
        if (event.valueIndex !== null) {
            this.filterService.removeFilterValue(event.filter, event.valueIndex);
        } else {
            this.appliedFilters = this.appliedFilters.filter(
                (f) => f.code !== event.filter.code
            );
            this.filterService.removeFilter(event.filter);
        }
        this.filterService.triggerFilter();
    }

    applyAllFromNavigation() {
        const nav = this.nav.current;
        const code = nav.fragmentTopic;
        if (!code || "" === code) {
            this.selectedFilterCode = "";
        } else {
            this.selectedFilterCode = code;
        }
    }
}